/**
 * @prettier
 */

import React from 'react';
import Canvas from './Canvas';

// We need to import this directly to download the custom fonts when referenced in the preview.
import 'cards/stylesheets/_fonts.less';

const OrderPreview = ({ width, page }) => {
  return <Canvas width={width} page={page} />;
};

export default OrderPreview;



// WEBPACK FOOTER //
// ./src/cards/components/common/SingleSample/SamplePreview/OrderPreview.jsx